import { FlexDiv, FlexContainer } from "@/components/Atoms";
import Typography from "@/foundation/Typography/V2";
import styled from "styled-components";

const PageContainer = styled(FlexContainer)`
  flex-direction: column;
  align-items: center;
  max-width: 1600px;
  padding: 0;
`;

const PageTitle = styled(Typography)`
  text-align: center;
  padding: 56px 40px 56px 40px;
  max-width: ${({ hasRecipeGroupedByParameter }) => {
    return !hasRecipeGroupedByParameter ? "600px" : "unset";
  }};
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 66px;
  background: linear-gradient(90.29deg, #12b76a 0.17%, #96b712 106.86%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;

  @media (max-width: 650px) {
    padding: 32px 16px;
    max-width: unset;
    font-size: 28px;
    line-height: 38.25px;
  }
`;

const PageSubtitle = styled(Typography)`
  text-align: center;
  max-width: 800px;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 25px;
  color: #293056;
  margin-bottom: 56px;
  display: none;
  padding: 0;
  margin: 0;
  @media (max-width: 650px) {
    margin-bottom: 0;
    // padding: 0 16px 32px 16px;
    max-width: unset;
    font-size: 14px;
    line-height: 18px;
  }
`;

const LoaderContainer = styled(FlexDiv)`
  justify-content: center;
  align-items: center;
  padding: 80px;
`;

const BreadcrumbWrapper = styled(FlexDiv)`
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  background-color: #f6fef9;
  .breadcrumbWrapper {
    width: 100%;
    max-width: 1312px;
    margin: 0 auto;
    padding: 16px 40px;
    z-index: 1;
    .title {
      color: #282828 !important;
    }
    @media (min-width: 650px) {
      margin-bottom: -80px;
    }
    @media (max-width: 650px) {
      margin-bottom: -32px;
      padding: 16px;
    }
  }
`;

export {
  PageContainer,
  PageTitle,
  PageSubtitle,
  LoaderContainer,
  BreadcrumbWrapper,
};
